/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesTournamentsEndpointsContractsTournamentsCreateTournamentRequest { 
    lpgaId?: number;
    tourId?: string;
    templateId?: number;
    year?: string;
    name?: string;
    number?: number;
    city?: string;
    stateId?: number;
    countryId?: number;
    startDate?: Date;
    endDate?: Date;
    purse?: number;
    sponsor?: string;
    sponsorSeries?: string;
    trimester?: number;
    seasonHalf?: number;
    playoffCategory?: string;
    scoringTypeId?: number;
    active?: boolean;
    official?: boolean;
}